import React, { useState } from 'react'
import { Button, Select } from 'antd'
import { DownloadOutlined, SearchOutlined, FilterOutlined } from '@ant-design/icons'
import PageHeader from '@/components/common/PageHeader'

export const JobsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [searchTerm, setSearchTerm] = useState('')
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')

  const quotes: any[] = []
  const filteredQuotes: any[] = []
  const paginatedQuotes: any[] = []

  const handleClearFilters = () => {
    setSearchTerm('')
    setDateFrom('')
    setDateTo('')
  }

  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Jobs"
        subtitle="View and manage all quotes and orders"
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Jobs' },
        ]}
      />

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <div className="flex gap-0">
          <button
            className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 0 ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
            onClick={() => { setActiveTab(0); setPage(0); }}
          >
            QUOTES ({quotes.length})
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 1 ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
            onClick={() => { setActiveTab(1); setPage(0); }}
          >
            ORDERS ({quotes.length})
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white rounded-lg shadow p-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
          <div className="relative">
            <SearchOutlined className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              className="w-full pl-9 pr-3 py-1.5 border border-gray-300 rounded text-sm"
              placeholder="Search by reference..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Select
            className="w-full"
            size="small"
            placeholder="All Customers"
            allowClear
            options={[]}
          />
          <input
            type="date"
            className="w-full px-3 py-1.5 border border-gray-300 rounded text-sm"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
          <input
            type="date"
            className="w-full px-3 py-1.5 border border-gray-300 rounded text-sm"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />
          <Button size="small" onClick={handleClearFilters} icon={<FilterOutlined />}>
            Clear
          </Button>
        </div>
      </div>

      {/* Export */}
      <div className="flex justify-end">
        <Button type="primary" icon={<DownloadOutlined />} disabled={filteredQuotes.length === 0}>
          Export CSV ({filteredQuotes.length} records)
        </Button>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-gray-600">Reference</th>
                <th className="px-4 py-3 text-left font-medium text-gray-600">Customer</th>
                <th className="px-4 py-3 text-left font-medium text-gray-600">Status</th>
                <th className="px-4 py-3 text-left font-medium text-gray-600">Region</th>
                <th className="px-4 py-3 text-left font-medium text-gray-600">Quote Date</th>
                <th className="px-4 py-3 text-right font-medium text-gray-600">Value</th>
                <th className="px-4 py-3 text-center font-medium text-gray-600">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {paginatedQuotes.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center py-16 text-gray-500">
                    No {activeTab === 0 ? 'quotes' : 'orders'} found
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 text-sm text-gray-600">
          <span>Showing 0 of 0</span>
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              className="border border-gray-300 rounded px-2 py-1 text-sm"
              value={rowsPerPage}
              onChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
            >
              {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
            <Button size="small" disabled={page === 0} onClick={() => setPage(p => p - 1)}>Prev</Button>
            <Button size="small" disabled onClick={() => setPage(p => p + 1)}>Next</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JobsPage
